import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '../../atoms/dialog/Dialog';
import { TDButton, TDTypography } from '../../atoms/TDUILib';
import { useAnalysis } from '../../utils/contexts/AnalysisContext';
import './CreateClassDialog.scss';

export default function CreateClassDialog({ isDialogOpen, setIsDialogOpen }) {
  const { t } = useTranslation();
  const [isFreeTrial, setIsFreeTrial] = useState(false);
  const { trackRawEvent, ANALYSIS_SEGMENT } = useAnalysis();

  const registeredUserTexts = {
    descriptionText: t('create_class_dialog_description'),
    buttonText: t('button_accept')
  };

  const freeTrialUserTexts = {
    descriptionText: t('create_class_dialog_description_free_trial'),
    buttonText: t('button_accept_free_trial')
  };

  function getWhoAmI() {
    const userWhoAmI = localStorage.getItem('bb_user_whoami');
    if (!userWhoAmI) {
      return false;
    }
    try {
      return JSON.parse(userWhoAmI);
    } catch (error) {
      return {};
    }
  }

  useEffect(() => {
    if (isDialogOpen) {
      setIsFreeTrial(getWhoAmI()?.is_self_registered);
      trackRawEvent(ANALYSIS_SEGMENT.SEGMENT_EVENTS.Create_Class_Clicked, {
        is_free_trial: isFreeTrial
      });
    }
  }, [isDialogOpen]);

  const texts = isFreeTrial ? freeTrialUserTexts : registeredUserTexts;

  return (
    <Dialog
      className='create-class-dialog'
      title={t('create_class_dialog_title')}
      isOpen={isDialogOpen}
      onClose={() => {
        setIsDialogOpen(false);
      }}
      showCloseButton={false}
    >
      <div className='create-class-dialog__content'>
        <TDTypography as='p' variant='body-m'>
          {t(texts.descriptionText)}
        </TDTypography>

        <div className='create-class-dialog__content__controls'>
          <TDButton
            onClick={() => {
              setIsDialogOpen(false);
            }}
            variant='outline'
            color='primary'
          >
            {t(texts.buttonText)}
          </TDButton>
        </div>
      </div>
    </Dialog>
  );
}
